import { useState } from "react";
import NavOverlay from "../NavOverlay/NavOverlay";
import { motion, AnimatePresence } from "framer-motion";
import { letterAnimation } from "../../variants/variants";
import "./Navbar.scss";

const Navbar = ({ setCursorVariant }) => {
  const [showOverlay, setShowOverlay] = useState(false);
  function handleClick() {
    setShowOverlay((showOverlay) => !showOverlay);
  }
  function navItemVariant(type = "") {
    if (type === "min")
      return {
        initial: {
          translateY: window.innerHeight / 2 - 25,
          scale: 2.5,
        },
        animate: {
          translateY: 0,
          scale: 1,
        },
        transition: {
          duration: 1,
          ease: "easeOut",
        },
      };
    return {
      initial: {
        translateY: window.innerHeight / 2,
        scale: 3,
      },
      animate: {
        translateY: 0,
        scale: 1,
      },
      transition: {
        duration: 1,
        ease: "easeOut",
      },
    };
  }
  return (
    <div className="navbar">
      <AnimatePresence>
        {showOverlay && (
          <NavOverlay
            setShowOverlay={setShowOverlay}
            setCursorVariant={setCursorVariant}
          />
        )}
      </AnimatePresence>
      <motion.div
        variants={navItemVariant()}
        initial="initial"
        animate="animate"
        className="brand"
      >
        vaibhav dhiman full stack developer
      </motion.div>
      <motion.div
        variants={navItemVariant("min")}
        initial="initial"
        animate="animate"
        className="menu"
        onClick={handleClick}
      >
        <div className={showOverlay ? `cross1` : "line1"}></div>
        <div className={showOverlay ? `cross2` : "line2"}></div>
      </motion.div>
    </div>
  );
};

export default Navbar;
